import styled from "@emotion/styled";

export const BuildingContainer = styled.div`
  width: 160px;
  height: 220px;
  display: flex;
  flex-direction: column;
  border-radius: 0px 0px 8px 8px;
  box-shadow: var(--alias-style-shadow-strong);
  box-sizing: border-box;
  background-color: white;
`;

export const ListContainer = styled.div`
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;

  ::-webkit-scrollbar {
    background-color: white;
    width: 10px;
    padding-right: 6px;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: var(--component-color-fill-strong);
  }
`;
